import React from 'react';
import { Box } from '@mui/material';

interface ParticipantLabelProps {
  role: string;
}

const ParticipantLabel: React.FC<ParticipantLabelProps> = ({ role }) => {
  const roleLower = role.toLowerCase();

  // Define styles based on role
  const getStyle = () => {
    if (roleLower === 'panel member') {
      return {
        color: '#175CD3', // blue-700
        backgroundColor: '#EFF8FF', // blue-50
        border: '1.5px solid #B2BDFF', // blue-200
      };
    } else if (roleLower === 'stakeholder') {
      return {
        color: '#6941C6', // gray-700
        backgroundColor: '#F9F5FF', // gray-50
        border: '1.5px solid #E9D7FE', // gray-200
      };
    } else {
      // Default/fallback style
      return {
        color: '#6B7280', // gray-600
        backgroundColor: '#F3F4F6', // gray-100
        border: '1.5px solid #D1D5DB', // gray-300
      };
    }
  };

  const style = getStyle();

  return (
    <Box
      sx={{
        display: 'inline-block',
        px: 2,
        py: 0.5,
        fontSize: '0.875rem',
        fontWeight: 500,
        borderRadius: '9999px',
        textTransform: 'capitalize',
        ...style,
      }}
    >
      {role}
    </Box>
  );
};

export default ParticipantLabel;
